export * from 'src/core/mocks/FeedbackStore';
export * from 'src/core/mocks/AccountStore';
export * from 'src/core/mocks/CoreConfig';
export * from 'src/core/mocks/ChainStore';
export * from 'src/core/mocks/ContractStore';
export * from 'src/core/mocks/EVMStore';
export * from 'src/core/mocks/PlatformStore';

export const CURRENT_CONTEXT = 'current';
